<template>
    <div class="pa-3">
        <div class="banner">
            <v-icon color="white" class="ml-2">mdi-shield</v-icon>
            <h4>{{ title }} - {{ patientName }}</h4>
        </div>
        <div>
            <v-form @submit.prevent="changeStatus" ref="form" :disabled="disableForm">
                <v-row>
                    <v-col class="d-flex" cols="12" sm="6">
                        <v-select :items="donor_status" label="Status Atual" disabled class="rounded-lg" color="#086318"
                            v-model="admControlForm.current_status" item-value="id" item-text="name" dense outlined>
                        </v-select>
                    </v-col>
                    <v-col class="d-flex" cols="12" sm="6">
                        <v-select :items="donor_status" label="Status Novo" :rules="formRules" class="rounded-lg"
                            color="#086318" v-model="admControlForm.new_status" item-value="id" item-text="name" dense
                            outlined>
                        </v-select>
                    </v-col>
                </v-row>
                <v-row class="mb-3 mr-1 d-flex justify-end">
                    <v-btn class="roundend-lg" small text @click="closeDialog()">
                        {{$t('buttons.cancel')}}
                    </v-btn>
                    <v-btn class="rounded-lg" dark elevation="0" :loading="loading" color="#575857" small type="submit">
                        {{$t('buttons.save')}}
                    </v-btn>
                </v-row>
            </v-form>
        </div>
    </div>
</template>
<script>
import axios from "@/axios";
import { mapActions } from "vuex";
import FormFieldsService from '@/service/FormFieldsService';
import Formatters from "@/utils/Formatters";
export default {
    data() {
        return {
            title: 'Controle ADM',
            admControlForm: {},
            donor_status: [],
            formRules: [(v) => !!v || "Campo obrigatório."],
            loading: false,
        }
    },

    computed: {
        patientName() {
            return this.resource.name
        }
    },

    async mounted() {
        this.donor_status = await FormFieldsService.getDonorStatus();
        this.admControlForm.current_status = parseInt(this.resource.donor_status_id);
    },

    watch: {
        'resource': {
            handler(item) {
                this.fillForm(item);
            },
            immediate: true,
            deep: true
        }
    },

    props: {
        resource: Object,
    },

    methods: {
        ...mapActions([
            "changeSnackBarData",
        ]),

        fillForm(item) {
            this.admControlForm.current_status = parseInt(item.donor_status_id);
        },

        changeStatus() {
            if (this.$refs.form.validate()) {
                this.loading = true
                const donor_id = this.resource.id;
                const donor_status_id = this.admControlForm.new_status;

                axios.patch(`/donor/update_status/${donor_id}`, { donor_status_id }).then((response) => {
                    this.changeSnackBarData({
                        status: true,
                        type: "success",
                        titleMessage: response.data.message,
                        bodyMessage: "",
                        cardColor: "#41916b",
                        titleIcon: "mdi-checkbox-marked-circle",
                    });

                    setTimeout(() => {
                        this.loading = false
                        this.closeSnackBar();
                        this.closeDialog();
                        this.$emit("updateGrid");
                    }, 3000);
                }).catch((err) => {
                    this.loading = false
                    this.changeSnackBarData({
                        status: true,
                        type: "erro",
                        titleMessage: "Algo deu errado!",
                        bodyMessage: Formatters.formatErrorMessage(err),
                        cardColor: "red",
                        titleIcon: "mdi-alert",
                    });

                    setTimeout(() => {
                        this.closeSnackBar();
                    }, 5000);
                });
            }
        },

        closeDialog() {
            this.admControlForm = {};
            this.$refs.form.resetValidation();
            this.$emit("closeDialog");
        },

        closeSnackBar() {
            this.changeSnackBarData({
                status: false,
                type: "",
                titleMessage: "",
                bodyMessage: "",
                cardColor: "",
                titleIcon: "",
            });
        },
    }
}
</script>
<style scoped>
.banner {
    background: #b3ffab;
    background: -webkit-linear-gradient(to right,
            #a5a5a5,
            #2a7c6c);
    background: linear-gradient(to right,
            #575857,
            #cfcfcf);

    border-radius: 8px;

    margin-bottom: 20px;

    display: flex;
    align-items: center;
}

.banner>h4 {
    color: #ffffff;
    padding: 10px;
}
</style>